import React, { createContext, useContext } from 'react';

interface OnlineUsersContextType { onlineCount: number; }
const OnlineUsersContext = createContext<OnlineUsersContextType>({ onlineCount: 0 });

// Online-presence tracking removed to cut realtime DB load.
export const OnlineUsersProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <OnlineUsersContext.Provider value={{ onlineCount: 0 }}>{children}</OnlineUsersContext.Provider>
);

export const useOnlineUsers = () => useContext(OnlineUsersContext).onlineCount;
